export default __webpack_public_path__ + "static/media/foodbeverage-icon.27373fbb.svg";